import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Promise from 'bluebird';
import {
  Dialog, DialogFooter,
  PrimaryButton, DefaultButton,
} from '@bingads-webui-react/fabric-control';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { UiBlocker } from '@bingads-webui-react/ui-blocker';
import { getDialogImageExtensionStyle } from '../styles/image-extension-dialog-style';

export const DeleteImageExtensionDialog = ({
  i18n,
  deleteImageExtension,
  selectedImageDelete,
  onDeleteSuccess,
  onCancel,
}) => {
  const dialogContentProps = { title: i18n.getString(_TL_('Are you sure?')) };
  const classes = useDefaultStyles(getDialogImageExtensionStyle);
  const [loading, setLoading] = useState(false);

  const onDeleteButtonClicked = () => {
    setLoading(true);
    // After a design change, deleteImageExtension is sync. Keep promise to support both modes
    Promise.resolve(deleteImageExtension(selectedImageDelete))
      .finally(() => {
        setLoading(false);
      })
      .then(() => {
        onDeleteSuccess();
      });
  };

  return (
    <Dialog
      hidden={false}
      onDismiss={onCancel}
      dialogContentProps={dialogContentProps}
      modalProps={{
        isBlocking: true,
        topOffsetFixed: true,
        className: classnames(classes.container, 'delete-img-ex-dialog'),
      }}
      minWidth={420}
      isClickableOutsideFocusTrap
    >
      <UiBlocker
        blocking={loading}
        loadingText={i18n.getString(_TL_('Deleting ...'))}
      >
        <div>{i18n.getString(_TL_('Deleting this image extension will remove it from all ads in this ad group that use it but will not delete it from your image extension library. Are you sure you want to remove this image extension from your ad?'))}</div>
        <DialogFooter>
          <PrimaryButton
            onClick={onDeleteButtonClicked}
            text={i18n.getString(_TL_('Yes, delete'))}
          />
          <DefaultButton onClick={onCancel} text={i18n.getString(_TL_('Cancel'))} />
        </DialogFooter>
      </UiBlocker>
    </Dialog>
  );
};

DeleteImageExtensionDialog.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  deleteImageExtension: PropTypes.func.isRequired,
  selectedImageDelete: PropTypes.shape({
    Id: PropTypes.number,
    Asset: PropTypes.shape({
      Id: PropTypes.number.isRequired,
      IdString: PropTypes.string.isRequired,
      ImageUrl: PropTypes.string.isRequired,
    }),
  }).isRequired,
  onDeleteSuccess: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

DeleteImageExtensionDialog.defaultProps = {
};
